import { themr } from '@friendsofreactjs/react-css-themr';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import intlEquipped from '../../../../../hocs/intlEquipped';
import NonInstantDetailsContent from './NonInstantDetailsContent';
import { actions as modalsActions } from '../../../../../redux/modals';
import { INVOICES } from '../../../../../modal/types';

const mapDispatchToProps = dispatch => ({
    openInvoicesModal: () => dispatch(modalsActions.showModal(INVOICES)),
});

export default compose(
    connect(null, mapDispatchToProps),
    themr('SapiSubscriptionModuleNonInstantDetailsContent'),
    intlEquipped
)(NonInstantDetailsContent);
